// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2phET","badges":"styles_badges__1jDpU"};